<template>
    <section class="features-section">
        <div class="features-container">
            <h2 class="section-title">Powerful Asset Management</h2>
            <p class="section-subtitle">From IT equipment to fleet vehicles, manage all your organization's assets in
                one central platform.</p>

            <div class="features">
                <div class="feature-card">
                    <div class="feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                            <line x1="8" y1="21" x2="16" y2="21"></line>
                            <line x1="12" y1="17" x2="12" y2="21"></line>
                        </svg>
                    </div>
                    <h3 class="feature-title">Complete Asset Lifecycle</h3>
                    <p class="feature-desc">Track assets from procurement to retirement. Manage warranties, maintenance
                        schedules, and depreciation all in one place.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                        </svg>
                    </div>
                    <h3 class="feature-title">Real-time Monitoring</h3>
                    <p class="feature-desc">Get instant visibility of asset status, location, and utilization. Set up
                        alerts for maintenance needs or unusual activity.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                            <path d="M2 17l10 5 10-5"></path>
                            <path d="M2 12l10 5 10-5"></path>
                        </svg>
                    </div>
                    <h3 class="feature-title">Supply Chain Integration</h3>
                    <p class="feature-desc">Connect purchasing, receiving, and inventory systems for seamless supply
                        chain management. Automate reordering based on stock levels.</p>
                </div>
            <!-- </div>

            <div class="features"> -->
                <div class="feature-card">
                    <div class="feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                    </div>
                    <h3 class="feature-title">User & Role Management</h3>
                    <p class="feature-desc">Set granular permissions for different teams. Track who has which assets
                        with detailed check-in/check-out history.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                            <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                        </svg>
                    </div>
                    <h3 class="feature-title">Advanced Analytics</h3>
                    <p class="feature-desc">Generate insightful reports on asset utilization, maintenance costs, and
                        depreciation. Make data-driven decisions to optimize your asset portfolio.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="3" y1="9" x2="21" y2="9"></line>
                            <line x1="9" y1="21" x2="9" y2="9"></line>
                        </svg>
                    </div>
                    <h3 class="feature-title">Customizable Workflows</h3>
                    <p class="feature-desc">Create approval processes for asset requests, configure maintenance
                        schedules, and automate common inventory tasks.</p>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import CircleCheckIcon from "@/components/ui/icons/CircleCheckIcon.vue";
import FileTextIcon from "@/components/ui/icons/FileTextIcon.vue";
import ShieldIcon from "@/components/ui/icons/ShieldIcon.vue";
import BookIcon from "@/components/ui/icons/BookIcon.vue";
import MessageIcon from "@/components/ui/icons/MessageIcon.vue";
import BranchIcon from "@/components/ui/icons/BranchIcon.vue";
export default {
    name: 'featuresSection1',
    components: {
        // CircleCheckIcon,
        // FileTextIcon,
        // ShieldIcon,
        // BookIcon,
        // MessageIcon,
        // BranchIcon,
    },
    data() {
        return {
            formTitle: 'Customer Feedback Form',
            fieldLabel: '',
            fieldPlaceholder: '',
            fieldValidation: 'Required',
            formComponents: [
                'Text Input',
                'Select Menu',
                'Radio Group'
            ],
            features: [
                {
                    icon: FileTextIcon,
                    title: 'Smart Templates',
                    description: 'Start with pre-built templates or create your own. Customize every aspect to match your needs.'
                },
                {
                    icon: CircleCheckIcon,
                    title: 'Real-time Validation',
                    description: 'Ensure data quality with built-in validation rules and custom logic that runs in real-time.'
                },
                {
                    icon: ShieldIcon,
                    title: 'Enterprise Security',
                    description: 'Bank-level encryption and compliance with major security standards to protect your data.'
                },
                {
                    icon: BookIcon,
                    title: 'Documentation',
                    description: 'Access detailed documentation, video tutorials, code examples, and best practices to quickly build and deploy your forms.'
                },
                {
                    icon: MessageIcon,
                    title: 'Live Chat',
                    description: 'Connect with our expert support team 24/7 for immediate assistance with technical issues, form design, or platform features.'
                },
                {
                    icon: BranchIcon,
                    title: 'Real-time Collaboration',
                    description: 'Work together seamlessly with your team. Share, edit, and update forms in real-time.'
                },
            ]
        }
    },
}
</script>

<style scoped>
.features-section {
    background-color: #F9FAFB;
    background-image: url("../../assets/login.svg");
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    padding: 0.5rem;
}

.features-container {
    max-width: 72rem;
    margin: 0 auto;
    padding: 64px 16px;
}

.section-title {
    font-size: 2.25rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1rem;
}

.section-subtitle {
    font-size: 1.25rem;
    color: var(--secondary);
    text-align: center;
    margin-bottom: 3rem;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
}

.features {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
}

/* .features {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
} */

/* Small tablets and up - 2 columns */
/* @media (min-width: 600px) {
  .features {
    grid-template-columns: repeat(2, 1fr);
  }
} */

/* Larger screens - 4 columns */
/* @media (min-width: 1024px) {
  .features {
    grid-template-columns: repeat(4, 1fr);
  }
} */

/* Extra large screens - 6 columns */
/* @media (min-width: 1440px) {
  .features {
    grid-template-columns: repeat(6, 1fr);
  }
} */

.feature-card {
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 2rem;
    text-align: left;
    transition: transform 0.2s, box-shadow 0.2s;
}

.feature-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.feature-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 0.375rem;
    background-color: var(--primary);
    background-color: #f3f4f6;
    color: #000;
    margin-bottom: 1.5rem;
}

.feature-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
}

.feature-desc {
    color: var(--secondary);
}

@media (max-width: 640px) {}

@media (max-width: 960px) {}
</style>